import * as DisneyAccountManagementActions from './../actions/disney-plus-account-management.actions';

import {
  DisneyPlusWebTokenResource,
  TechnicalError,
} from '@dch/products-business-logic';

export interface DisneyPlusAccountManagementState {
  token: DisneyPlusWebTokenResource;
  isPending: boolean;
  error: TechnicalError;
}

export const initialState: DisneyPlusAccountManagementState = {
  token: null,
  isPending: false,
  error: null,
};

export function reducer(
  state: DisneyPlusAccountManagementState = initialState,
  action: DisneyAccountManagementActions.Actions,
): DisneyPlusAccountManagementState {
  switch (action.type) {
    case DisneyAccountManagementActions.GET_DISNEY_PLUS_WEB_TOKEN:
      return {
        ...state,
        isPending: true,
        error: null,
      };
    case DisneyAccountManagementActions.GET_DISNEY_PLUS_WEB_TOKEN_SUCCESS:
      return {
        ...state,
        token: action.payload,
        isPending: false,
        error: null,
      };
    case DisneyAccountManagementActions.GET_DISNEY_PLUS_WEB_TOKEN_FAILED:
      return {
        ...state,
        token: null,
        error: action.payload,
        isPending: false,
      };
    default:
      return state;
  }
}

export const getDisneyPlusToken = (state: DisneyPlusAccountManagementState) =>
  state.token;
export const getTechnicalError = (state: DisneyPlusAccountManagementState) =>
  state.error;
export const getPending = (state: DisneyPlusAccountManagementState) =>
  state.isPending;
